import SsoRoute from "./sso";

export default class LoginAphpMedicsRoute extends SsoRoute {}
